import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _findIndex from "lodash/findIndex";
import _includes from "lodash/includes";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import React from 'react';
import MarketplaceReviewLink from '@nerdwallet/react-marketplace-review-link';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import BaseContent from './base-content';
import { ProductCardContentTabEnum } from '../types/graphql/generated-types';
import { DEFAULT_TAB_ORDER, TRK_PRODUCT_LOCATION } from '../lib/constants';
import { buildTrkSectionCategory } from '../lib/utils';
import styles from "../marketplace-product-card.module.css";
var DEFAULT_ANALYTICS_CONFIG = {
  expandableContentProps: {},
  tabContentProps: {},
  tabProps: {
    onClickProps: {},
    onTabClickProps: {}
  }
};

/**
 * Map deprecated API to BaseContent.
 * @deprecated
 */
var MappedContent = function MappedContent(_ref) {
  var _ref$activeContentTab = _ref.activeContentTab,
    activeContentTab = _ref$activeContentTab === void 0 ? DEFAULT_TAB_ORDER[0] : _ref$activeContentTab,
    analytics = _ref.analytics,
    bottomLine = _ref.bottomLine,
    className = _ref.className,
    cons = _ref.cons,
    enableAnalytics = _ref.enableAnalytics,
    id = _ref.id,
    initTabContentExpanded = _ref.initTabContentExpanded,
    keyFacts = _ref.keyFacts,
    marketplaceEntity = _ref.marketplaceEntity,
    omitExpandFunctionalityOnMobile = _ref.omitExpandFunctionalityOnMobile,
    omittedTabs = _ref.omittedTabs,
    parentImpressionId = _ref.parentImpressionId,
    productDetails = _ref.productDetails,
    pros = _ref.pros,
    reviewLinkHref = _ref.reviewLinkHref,
    reviewLinkTabIndex = _ref.reviewLinkTabIndex,
    taxonomy = _ref.taxonomy,
    trkPageType = _ref.trkPageType,
    trkSectionCategory = _ref.trkSectionCategory,
    trkSectionPosition = _ref.trkSectionPosition;
  useDeprecatedPropsWarning({
    component: 'Content',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }, {
      version: '6.9.0',
      deprecated: 'parentImpressionId',
      migration: 'No longer used. It is retrieved with react context.'
    }],
    props: {
      enableAnalytics: enableAnalytics,
      parentImpressionId: parentImpressionId
    }
  });
  var passThroughProps = {
    analytics: analytics || enableAnalytics && DEFAULT_ANALYTICS_CONFIG,
    bottomLine: bottomLine,
    className: className,
    cons: cons,
    id: id,
    isInitTabContentExpanded: initTabContentExpanded,
    keyFacts: keyFacts,
    productDetails: productDetails,
    pros: pros,
    reviewLinkTabIndex: reviewLinkTabIndex,
    shouldOmitExpandFunctionalityOnMobile: omitExpandFunctionalityOnMobile,
    trkPageType: trkPageType,
    trkSectionCategory: trkSectionCategory,
    trkSectionPosition: trkSectionPosition
  };

  // Calculate tab ordering
  var tabs = DEFAULT_TAB_ORDER.filter(function (tab) {
    return !_includes(omittedTabs, tab);
  });
  var activeTabIndex = _findIndex(tabs, function (tab) {
    return tab === activeContentTab;
  });
  var initialActiveTabIndex = activeTabIndex >= 0 ? activeTabIndex : 0;
  var initialTab = tabs[initialActiveTabIndex];
  var reorderedTabs = initialActiveTabIndex ? [initialTab].concat(_toConsumableArray(tabs.filter(function (_unused, i) {
    return initialActiveTabIndex !== i;
  }))) : tabs;
  return /*#__PURE__*/React.createElement(BaseContent, _extends({}, passThroughProps, {
    tabs: reorderedTabs,
    reviewLinkNode: /*#__PURE__*/React.createElement(MarketplaceReviewLink, {
      className: styles.tabContent_reviewLink,
      marketplaceEntity: marketplaceEntity,
      href: reviewLinkHref,
      text: "Read full review",
      trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
      ,
      trkPageType: trkPageType,
      trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'tabs'),
      trkTaxonomy: taxonomy
    })
  }));
};
if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
  var PropTypes = require('prop-types');
  MappedContent.propTypes = {
    analytics: PropTypes.object,
    activeContentTab: PropTypes.oneOf(Object.values(ProductCardContentTabEnum)),
    bottomLine: PropTypes.node,
    className: PropTypes.string,
    cons: PropTypes.arrayOf(PropTypes.node),
    /** @deprecated */
    enableAnalytics: PropTypes.bool,
    id: PropTypes.string,
    initTabContentExpanded: PropTypes.bool,
    keyFacts: PropTypes.node,
    marketplaceEntity: PropTypes.object.isRequired,
    omitExpandFunctionalityOnMobile: PropTypes.bool,
    omittedTabs: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductCardContentTabEnum))),
    /** @deprecated */
    parentImpressionId: PropTypes.string,
    productDetails: PropTypes.node,
    pros: PropTypes.arrayOf(PropTypes.node),
    reviewLinkHref: PropTypes.string,
    reviewLinkTabIndex: PropTypes.number,
    taxonomy: PropTypes.object,
    trkPageType: PropTypes.string,
    trkSectionCategory: PropTypes.string,
    trkSectionPosition: PropTypes.number
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
}

export default MappedContent;